import { Code, Puzzle, Shield, Sun, Rocket } from "components/icons/generated";
import { IconEmphasizedColor } from "ds/components/IconEmphasized/types";
import { IconComponent } from "types/Icon";

export const randomIconAndColor = () => {
  const icons = [Rocket, Code, Puzzle, Shield, Sun];
  const colors: IconEmphasizedColor[] = ["green", "blue", "turquoise", "fuchsia", "orange"];
  return {
    icon: icons[Math.floor(Math.random() * icons.length)],
    color: colors[Math.floor(Math.random() * colors.length)],
  };
};

const hardcodedUserGuideGroupColorsAndIcons: Array<{
  id: string;
  icon: IconComponent;
  color: IconEmphasizedColor;
}> = [
  {
    id: "foundations",
    icon: Sun,
    color: "green",
  },
  {
    id: "operational-safety",
    icon: Shield,
    color: "blue",
  },
  {
    id: "configuration-reuse",
    icon: Puzzle,
    color: "turquoise",
  },
  {
    id: "delivery-at-scale",
    icon: Rocket,
    color: "fuchsia",
  },
];

export const getHardcodedUserGuideGroupIconAndColor = (id: string) => {
  const colorAndIcon = hardcodedUserGuideGroupColorsAndIcons.find(
    (colorAndIcon) => colorAndIcon.id === id
  );
  if (!colorAndIcon) {
    return randomIconAndColor();
  }

  return {
    icon: colorAndIcon.icon,
    color: colorAndIcon.color,
  };
};
